import { LazyAction, LazyImport, LazyModule, registerLazyOrchestrator } from 'owa-bundling';

/* Legacy actions */
export { default as setListViewDimension } from './legacyActions/setListViewDimension';

/* Utils */
export { default as getSearchBoxLeftPadding } from './utils/getSearchBoxLeftPadding';
export { default as getLeftNavWidth } from './utils/getLeftNavWidth';
export { default as getListViewDimensions } from './utils/getListViewDimensions';
export { default as getDataMinMaxWidthsForLeftNav } from './utils/getDataMinMaxWidthsForLeftNav';
export {
    default as getListViewNotificationDimensions,
} from './utils/getListViewNotificationDimensions';

/* Selectors */
export {
    isReadingPanePositionBottom,
    isReadingPanePositionOff,
    isReadingPanePositionRight,
} from './selectors/readingPanePosition';

export { default as isImmersiveReadingPaneShown } from './selectors/isImmersiveReadingPaneShown';
export { default as shouldShowListView } from './selectors/shouldShowListView';
export { default as shouldShowReadingPane } from './selectors/shouldShowReadingPane';
export { default as shouldShowFolderPane } from './selectors/shouldShowFolderPane';
export {
    getLeftPaneStyles,
    getRightPaneStyles,
    getListViewContainerStyles,
    getReadingPaneContainerStyles,
} from './selectors/getMailComponentStyles';
export { isSingleLineListView } from './selectors/listViewLayout';

export {
    DEFAULT_LIST_VIEW_WIDTH,
    MAX_LIST_VIEW_HEIGHT,
    MAX_LIST_VIEW_WIDTH,
    MIN_LIST_VIEW_HEIGHT,
    MIN_LIST_VIEW_WIDTH,
    MIN_WINDOW_WIDTH,
} from './mailLayoutConstants';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailLayout", webpackPrefetch: true */ './lazyIndex')
);

export let lazyToggleFolderPaneExpansion = new LazyAction(
    lazyModule,
    m => m.toggleFolderPaneExpansion
);

/* V3 actions */
export { initializeMailLayout } from './actions/initializeMailLayout';
export { onClientReadingPanePositionChange } from './actions/onClientReadingPanePositionChange';
import { leftPaneResized } from './actions/leftPaneResized';
export { leftPaneResized };

export const lazyInitializeDynamicLayout = new LazyImport(
    lazyModule,
    m => m.initializeDynamicLayout
);

/* Register orchestrators and mutators */

export { setShowListPane } from './actions/setShowListPane';
export { setShowReadingPane } from './actions/setShowReadingPane';

import './orchestrators/initializeMailLayoutOrchestrator';
import './mutators/setShowListPaneMutator';
import './mutators/setShowReadingPaneMutator';

registerLazyOrchestrator(leftPaneResized, lazyModule, m => m.leftPaneResizedOrchestrator);
